export const excludedCats = ['DocCons', 'certs', 'subscr', 'express-specialist-referrals', 'patho'];
